import { IGachNoRequest } from "../../../model/request/dong-bo/IGachNoRequest";
import { IGachNoResponse } from "../../../model/respone/dong-bo/IGachNoResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eGachNoThuCongActionsObj = {
  SELECTED_NGAN_HANG: "",
  CHANGE_STEP: 0,
  GACH_NO_START: {} as IGachNoRequest,
  GACH_NO_SUCCESS: {} as IGachNoResponse,
  GACH_NO_ERR: {} as string,
  CHANGE_REQUEST: {} as any,
  RESET_RESULT: undefined,
};

export const eGachNoThuCongActionTypeIds = generateActionTypeIds(
  eGachNoThuCongActionsObj,
  "GACH_NO_THU_CONG",
);
export type IGachNoThuCongActionTypes = IGenericActionType<
  typeof eGachNoThuCongActionsObj,
  "GACH_NO_THU_CONG"
>;
